import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootDispatch } from '../store';
import { VWRCallEvent } from '../types';
import { dateToHourMinMeridiem } from '../util';
import { ReactComponent as AvatarProviderSvg } from '../images/avatar-provider.svg';
import { ReactComponent as CancelIconSvg } from '../images/icon-cancel-circle-blue.svg';
import { ReactComponent as VideoCameraIconSvg } from '../images/icon-video-camera.svg';
import styles from './JoinVWRCallModal.module.css';

export function JoinVWRCallModal({
  callEvent,
  joinCall,
  hideCallModal,
}: {
  callEvent: VWRCallEvent;
  joinCall: (_: unknown) => void;
  hideCallModal: () => void;
}) {
  const messageDate = dateToHourMinMeridiem(callEvent.receivedAt);

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <CancelIconSvg className={styles.cancelIcon} onClick={hideCallModal} />
        <AvatarProviderSvg className={styles.providerIcon} />
        <p className={styles.invitationSenderName}>{callEvent.provider_display_name}</p>
        <div className={styles.invitationMessage}>
          <FormattedMessage id={'virtualWaitingRoom.call.invitationMessage'} />
        </div>
        <button className={styles.continuationButton} onClick={joinCall}>
          <VideoCameraIconSvg className={styles.cameraIcon} />
          <div className={styles.continuationMessage}>
            <FormattedMessage id={'virtualWaitingRoom.call.continueButton'} />
          </div>
        </button>
        <span className={styles.timestamp} aria-label="message-timestamp">
          {messageDate}
        </span>
      </div>
    </div>
  );
}

const mapDispatch = ({ virtualWaitingRoom: { hideCallModal, joinCall } }: RootDispatch) => ({
  hideCallModal,
  joinCall,
});

// https://tigertext.atlassian.net/browse/TMG-837
// @ts-expect-error
export default connect(null, mapDispatch)(JoinVWRCallModal);
